webpackJsonp([47],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	/* global require, ga, _hmt */
	var browser;
	
	browser = void 0;
	
	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(8);
	
	__webpack_require__(3);
	
	__webpack_require__(9);
	
	__webpack_require__(158);
	
	__webpack_require__(1);
	
	__webpack_require__(5);
	
	__webpack_require__(4);
	
	__webpack_require__(14);
	
	__webpack_require__(7);
	
	__webpack_require__(6);
	
	__webpack_require__(21);
	
	__webpack_require__(2);
	
	__webpack_require__(28);
	
	browser = {
	  isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	};
	
	(function() {
	  var $fixedshenqing;
	  $fixedshenqing = $('.fixed-shenqing');
	  if ($fixedshenqing.length > 0) {
	    return $(window).scroll(function() {
	      var scrollTop;
	      scrollTop = $(window).scrollTop();
	      if (480 <= scrollTop) {
	        return $fixedshenqing.stop().animate({
	          bottom: 0
	        }, 50);
	      } else {
	        return $fixedshenqing.stop().animate({
	          bottom: -85
	        }, 50);
	      }
	    });
	  }
	})();
	
	(function() {
	  var $form, $mobile, $truename;
	  if ($('#indextop').length > 0) {
	    $form = $('#indextop');
	    $truename = $form.find('[name="truename"]');
	    $mobile = $form.find('[name="mobile"]');
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            var $options1, $val1, ref, ref1;
	            $options1 = $("#quota option:selected");
	            $val1 = $options1.val();
	            if ($val1 === "0") {
	              swal({
	                title: '请填写申请额度！',
	                allowOutsideClick: true
	              });
	              return false;
	            }
	            if (((ref = res.msg) != null ? (ref1 = ref[0]) != null ? ref1.type : void 0 : void 0) === 'success') {
	              swal({
	                customClass: 'alert-success',
	                title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
	                confirmButtonText: '返  回',
	                confirmButtonColor: '#3b9bff',
	                allowOutsideClick: true,
	                html: true,
	                timer: 1000000
	              });
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    $mobile.rules('add', {
	      required: true,
	      mobileNum: true,
	      messages: {
	        required: '请输入11位手机号码',
	        mobileNum: '请输入正确的手机号'
	      }
	    });
	    return false;
	  }
	})();
	
	(function() {
	  var $calculate, $cycle, $cycle1, $error, $loanAmount, $loanAmount1, $monthlyRepayment, $total;
	  $calculate = $('#calculate');
	  $loanAmount = $('#loanAmount');
	  $cycle = $('#cycle');
	  $monthlyRepayment = $('#monthlyRepayment');
	  $loanAmount1 = $('#loanAmount1');
	  $cycle1 = $('#cycle1');
	  $total = $('#total');
	  $error = $("#error");
	  $loanAmount.blur(function() {
	    var $loanAmountval;
	    $loanAmountval = $loanAmount.val();
	    if (!$loanAmountval) {
	      $loanAmount.css({
	        "border": "1px solid #f53353"
	      });
	      $error.css({
	        "color": "#f53353"
	      });
	      $error.text("请输入贷款金额");
	    } else if ($loanAmountval > 160000) {
	      $loanAmount.css({
	        "border": "1px solid #f53353"
	      });
	      $error.css({
	        "color": "#f53353"
	      });
	      $error.text("贷款金额不能高于16万元");
	      return false;
	    } else if ($loanAmountval < 10000) {
	      $loanAmount.css({
	        "border": "1px solid #f53353"
	      });
	      $error.css({
	        "color": "#f53353"
	      });
	      $error.text("贷款金额不能低于1万元");
	      return false;
	    } else {
	      $loanAmount.css({
	        "border": "1px solid #e9ecf0"
	      });
	      $error.css({
	        "color": "#fff"
	      });
	    }
	    return $loanAmount1.text($loanAmountval);
	  });
	  return $calculate.click(function() {
	    var $loanAmountval, $options, $val, monthlyRepayment;
	    $loanAmountval = $loanAmount.val();
	    $options = $("#cycle option:selected");
	    $val = $options.val();
	    if (!$loanAmountval) {
	      swal({
	        title: "请输入贷款金额",
	        allowOutsideClick: true
	      });
	      return false;
	    } else if ($loanAmountval > 160000) {
	      swal({
	        title: "贷款金额不能高于16万元",
	        allowOutsideClick: true
	      });
	      return false;
	    } else if ($loanAmountval < 10000) {
	      swal({
	        title: "贷款金额不能低于1万元",
	        allowOutsideClick: true
	      });
	      return false;
	    }
	    if ($val === "6") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 6;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(6);
	      return $total.text((monthlyRepayment * 6).toFixed(2));
	    } else if ($val === "12") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 12;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(12);
	      return $total.text((monthlyRepayment * 12).toFixed(2));
	    } else if ($val === "18") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 18;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(18);
	      return $total.text((monthlyRepayment * 18).toFixed(2));
	    } else if ($val === "24") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 24;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(24);
	      return $total.text((monthlyRepayment * 24).toFixed(2));
	    } else if ($val === "36") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 36;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(36);
	      return $total.text((monthlyRepayment * 36).toFixed(2));
	    } else if ($val === "48") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 48;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(48);
	      return $total.text((monthlyRepayment * 48).toFixed(2));
	    } else if ($val === "60") {
	      monthlyRepayment = $loanAmountval * 0.0065 + $loanAmountval / 60;
	      $monthlyRepayment.text(monthlyRepayment.toFixed(2));
	      $cycle1.text(60);
	      return $total.text((monthlyRepayment * 60).toFixed(2));
	    } else {
	      swal({
	        title: $val,
	        allowOutsideClick: true
	      });
	      return false;
	    }
	  });
	})();


/***/ },

/***/ 158:
3

});


/** WEBPACK FOOTER **
 ** zfb.107317e26c9c1413412a.js
 **/